export default __webpack_public_path__ + "static/1656forging-c492e6bcb44f2be6ff9b7d7320bda298.jpg";